module.exports = __webpack_public_path__ + "media/images/advisor/img_2_1-f4280c92186e15fb9925e6dd3a05999f.png";